import { ApiResponse, InsuranceCard, IRequestOptions, IRequestConfig, getConfigs, axios, basePath } from "./index.defs";
import { CalcState } from "../models/Models";

export class InsuranceService {
    static saveIssue(payload: { cardId: string; icName: string; }): Promise<ApiResponse> {
        return new Promise((resolve, reject) => {
            const url = basePath + `/insurance/SaveIssue?icName=${payload.icName}&cardId=${payload.cardId}`;
            const configs: IRequestConfig = getConfigs("get", "application/json", url, { withCredentials: true });
            axios(configs, resolve, reject);
        });
    }

    static calculateFast(
        params: {
            /**  */
            traceId: string;
            /** requestBody */
            body?: InsuranceCard;
            icName?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CalcState> {
        return new Promise((resolve, reject) => {
            const url = basePath + `/insurance/calculateFast?icName=${params.icName}`;

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { traceId: params["traceId"] };
            configs.timeout = 120000;
            const data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    static code(
        params: {
            /**  */
            cardId: number;
            /**  */
            code: string;
            /**  */
            company: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/insurance/{company}/{cardId}/buy/code";
            url = url.replace("{cardId}", params["cardId"] + "");
            url = url.replace("{company}", params["company"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { code: params["code"] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }

    static async GetPercentageOfPassability(kladrId: string): Promise<{ icName: string; value: number }[]> {
        return new Promise((resolve, reject) => {
            const url = `${basePath}/insurance/SuccessPossibilityPercentage?kladrId=${kladrId}`;
            const configs: IRequestConfig = getConfigs("get", "application/json", url, { withCredentials: true });
            axios(configs, resolve, reject);
        });
    }
}
